import { styled } from '@mui/material';
import { ReactNode } from 'react';
import MuiDialog from '@mui/material/Dialog';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent, { DialogContentProps } from '@mui/material/DialogContent';
import MuiDialogActions, { DialogActionsProps } from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';

export interface DialogTitleProps {
  children?: React.ReactNode;
  onClose?: () => void;
}

const DialogTitle = (props: DialogTitleProps) => {
  const { children, onClose, ...other } = props;
  return (
    <MuiDialogTitle sx={{ margin: 0, padding: '20px 30px 5px 30px', minHeight: 30 }} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme => theme.palette.grey[500],
          }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
};

interface CustomDialogContentProps {
  unpaddingContent?: boolean;
}

const DialogContent = styled(MuiDialogContent)<DialogContentProps & CustomDialogContentProps>(
  ({ theme, unpaddingContent }) => ({
    padding: unpaddingContent ? 0 : '10px 30px 25px',
  })
);

const DialogActions = styled(MuiDialogActions)<DialogActionsProps>(({ theme }) => ({ margin: 0, padding: 0 }));

interface DialogProps {
  children: ReactNode;
  type?: string;
  open?: boolean;
  dividers?: boolean;
  fullScreen?: boolean;
  unpaddingContent?: boolean;
  title?: string;
  footer?: ReactNode;
  handleClose?: () => void;
}

const Dialog = ({
  children,
  open = true,
  dividers = true,
  fullScreen = false,
  unpaddingContent = false,
  title,
  footer,
  handleClose,
}: DialogProps) => {
  return (
    <MuiDialog open={open} fullScreen={fullScreen} onClose={handleClose} fullWidth>
      {(title || handleClose) && <DialogTitle onClose={handleClose}>{title}</DialogTitle>}
      <DialogContent dividers={dividers} unpaddingContent={unpaddingContent}>
        {children}
      </DialogContent>
      {footer && <DialogActions>{footer}</DialogActions>}
    </MuiDialog>
  );
};

export default Dialog;
